import Label from '../../../../components/label/label';
import Input from '../../../../components/input/input';
import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useAppointments } from '../../../../hooks/useAppointments';

function CreateAppointment({ onClose }) {
    const [startDate, setStartDate] = useState(new Date());
    const [description, setDescription] = useState('');
    const { id } = useParams();
    const modalRef = useRef(null);
    const { createAppointment } = useAppointments();

    const handleSubmit = async (e) => {
        e.preventDefault();
        createAppointment(startDate, description, id)
    };

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [onClose]);

    return (
        <div className='customerCreateAppointmentContainer'>
            <div
                ref={modalRef}
                className='customerCreateAppointmentWrapper'
            >
                <h2>Neuen Termin hinzufügen</h2>
                <form onSubmit={handleSubmit} className='customerCreateAppointmentForm'>
                    <div className='customerCreateAppointmentDatePicker'>
                        <DatePicker
                            wrapperClassName='datePicker'
                            selected={startDate}
                            onChange={date => setStartDate(date)}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            timeCaption="time"
                            dateFormat="MMMM d, yyyy h:mm aa"
                        />
                    </div>
                    <br />
                    <Label labelFor="description" labelValue="Notiz:" />
                    <Input
                        inputId="description"
                        inputName="description"
                        inputType="text"
                        color="white"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                    <br />
                    <Input
                        height="40px"
                        inputType="submit"
                        inputValue='Hinzufügen'
                        color="white"
                    />
                </form>
            </div>
        </div>
    );
}

export default CreateAppointment;